const inquiryConfig = window?.["inquiryConfig"];
export const contextPath = window?.["contextPath"] ?? "";
export const baseInquiryUrl = inquiryConfig?.baseInquiryApiURL ?? "";
export const inquiryCartUrl = inquiryConfig?.inquiryCartApiURL ?? "";
export const addToInquiryUrl = inquiryConfig?.addToInquiryApiURL ?? "";
